/* eslint-disable @typescript-eslint/no-explicit-any */

// Расширяем Window для GTM dataLayer и Яндекс Метрики
declare global {
  interface Window {
    dataLayer: Record<string, unknown>[]
    ym: (...args: any[]) => void
  }
}

/**
 * Отправляет конверсию sell_company_success.
 * Вызывать ТОЛЬКО после успешного ответа API (response.ok === true).
 * Не передаёт персональные данные пользователя.
 */
export function fireSellCompanySuccess(pathname: string): void {
  if (typeof window === 'undefined') return

  // GTM dataLayer
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'sell_company_success',
    form_type: 'sell',
    page_location: pathname
  })

  // Яндекс Метрика
  if (typeof window.ym === 'function') {
    window.ym(102974994, 'reachGoal', 'sell_company_success')
  }
}
